import React, { Component } from "react";
import { Route, Link, withRouter } from "react-router-dom";
import { withAuth } from "../AuthContext";
import TabLink from "../Utils/TabLink";
import Admins from "./admins/Admins";
import Posts from "./Posts";
import Pages from "./pages/Pages";
import EditPage from "./pages/EditPage";
import cloneDeep from "clone-deep"; // needed when resetting state
import PostForm from "./PostForm";
import AddAdmin from "./admins/AddAdmin";
import EditAdmin from "./admins/EditAdmin";
import PostPhoto from "./PostPhoto";
import EditFaqs from "./pages/EditFaqs";
import EditFaq from "./pages/EditFaq";
import EditFaqsTitle from "./pages/EditFaqsTitle";

class Dashboard extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        axios
            .get("/api/editor/loggedIn")
            .then((response) => {
                if (!response.data.loggedIn) {
                    this.props.history.push("/admin/login");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    render() {
        const links = this.props.links;
        const currentPath = window.location.pathname;

        // Find the most specific match
        const activeComponentIndex = links
            .map((link, index) => ({ index, length: link.path.length, matches: currentPath.startsWith(link.path) }))
            .filter(link => link.matches)
            .sort((a, b) => b.length - a.length)
            .map(link => link.index)[0] || -1;


        return (
            <section className="contact-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div className="">
                                <h3 className="title">Editor Dashboard</h3>
                                <ul className="nav nav-tabs justify-content-center">
                                    {links.map((link, i) => (
                                        <TabLink
                                            path={link.path}
                                            text={link.text}
                                            isActive={i === activeComponentIndex}
                                            key={link.path}
                                            onClick={() =>
                                                this.props.handleClick(i)
                                            }
                                        />
                                    ))}
                                </ul>
                                <Route
                                    exact
                                    path={`${this.props.match.url}/posts`}
                                    component={Posts}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/posts/add`}
                                    component={PostForm}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/posts/:id/edit`}
                                    component={PostForm}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/posts/:id/upload`}
                                    component={PostPhoto}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/admins`}
                                    component={Admins}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/admins/add`}
                                    component={AddAdmin}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/admins/:id`}
                                    component={EditAdmin}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/pages`}
                                    component={Pages}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/pages/:id`}
                                    component={EditPage}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/pages/:pageId/:categoryId`}
                                    component={EditFaqs}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/pages/:pageId/:categoryId/title/edit`}
                                    component={EditFaqsTitle}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}/pages/:pageId/:categoryId/:faqId`}
                                    component={EditFaq}
                                />
                                <Route
                                    exact
                                    path={`${this.props.match.url}`}
                                    render={() => {
                                        if (activeComponentIndex == 0)
                                            return <Posts />;
                                        // else if (activeComponentIndex == 1) return <Messages {...this.props} handleNav={this.props.handleClick}/>;
                                        else if (activeComponentIndex == 1)
                                            return <Admins />;
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(withAuth(Dashboard));
